import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import Venues from "@/pages/Venues";
import VenueDetail from "@/pages/VenueDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Sales from "@/pages/Sales";
import Sponsorships from "@/pages/Sponsorships";
import Finance from "@/pages/Finance";
import Team from "@/pages/Team";
import Documents from "@/pages/Documents";
import CalendarPage from "@/pages/CalendarPage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500">Loading GameLink OS...</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/tasks" element={<Protected><Tasks scope="mine" /></Protected>} />
          <Route path="/tasks/all" element={<Protected><Tasks scope="all" /></Protected>} />
          <Route path="/venues" element={<Protected><Venues /></Protected>} />
          <Route path="/venues/:id" element={<Protected><VenueDetail /></Protected>} />
          <Route path="/events" element={<Protected><Events /></Protected>} />
          <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
          <Route path="/sales" element={<Protected><Sales /></Protected>} />
          <Route path="/sponsorships" element={<Protected><Sponsorships /></Protected>} />
          <Route path="/finance" element={<Protected><Finance /></Protected>} />
          <Route path="/team" element={<Protected><Team /></Protected>} />
          <Route path="/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
